const last12CharsRegex = /(.+)(.{7}$)/;
const max30CharRegex = /(.{30})..+/;
const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export {
  last12CharsRegex,
  max30CharRegex,
  phoneRegex
}